<script lang="ts">
    let className = '';
    export let muted = false;
    export let volumeLevel = 0.5;
    export { className as class };
</script>

<svg
    width="100%"
    height="100%"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="{(volumeLevel === 0 || muted) && 'opacity-50'} {className}"
    on:click
>
    <g clip-path="url(#clip0_4608_19652)">
        <path
            d="M11.1702 11.7111L14.9746 8.42467C15.7845 7.72507 17.0417 8.3004 17.0417 9.37061V16.0501V22.7297C17.0417 23.7999 15.7845 24.3752 14.9746 23.6756L11.1702 20.3892C10.6707 19.9577 10.0326 19.7202 9.3725 19.7202H7.5C6.5335 19.7202 5.75 18.9367 5.75 17.9702V14.1301C5.75 13.1636 6.53349 12.3801 7.49999 12.3801L9.37247 12.3801C10.0326 12.3801 10.6706 12.1426 11.1702 11.7111Z"
            fill="white"
            stroke="white"
            stroke-width="1.5"
        />
        {#if !muted}
            {#if volumeLevel > 0}
                <!-- 1 level -->
                <path
                    d="M20.9897 19.2473C21.6591 18.3565 22.0557 17.2492 22.0557 16.0494C22.0557 14.8495 21.6591 13.7422 20.9897 12.8514"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                />
                <!-- end -->

                {#if volumeLevel > 0.51}
                    <!-- 2 level -->
                    <path
                        d="M23.1216 22.449C24.4603 20.6674 25.2535 18.4528 25.2535 16.0531C25.2535 13.6534 24.4603 11.4388 23.1216 9.65723"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                    />
                    <!-- end -->
                {/if}
            {/if}
        {:else}
            <!-- muted -->
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.8832 12.8404C20.2737 12.4499 20.9069 12.4499 21.2974 12.8404L26.2067 17.7497C26.5973 18.1402 26.5973 18.7734 26.2067 19.1639C25.8162 19.5544 25.1831 19.5544 24.7925 19.1639L19.8832 14.2546C19.4927 13.8641 19.4927 13.2309 19.8832 12.8404Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M26.2833 12.8404C25.8928 12.4499 25.2596 12.4499 24.8691 12.8404L19.9598 17.7497C19.5692 18.1402 19.5692 18.7734 19.9598 19.1639C20.3503 19.5544 20.9835 19.5544 21.374 19.1639L26.2833 14.2546C26.6738 13.8641 26.6738 13.2309 26.2833 12.8404Z"
                fill="white"
            />
            <!-- end -->
        {/if}
    </g>
    <defs>
        <clipPath id="clip0_4608_19652">
            <rect width="22" height="22" fill="white" transform="translate(5 5)" />
        </clipPath>
    </defs>
</svg>
